import { Component, OnInit } from '@angular/core';
import { PurchaseInvoiceService } from 'app/shared/services/purchase-invoice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-supplier-outstanding-report',
  templateUrl: './supplier-outstanding-report.component.html',
  styleUrls: ['./supplier-outstanding-report.component.css']
})
export class SupplierOutstandingReportComponent implements OnInit {

  searchKey : string;
  isDark: boolean = false;

  GRNList : any[]=[];
  filteredTypeList : any[]=[];
  filteredByNameList : any[]=[];
  filteredFinalList: any[]=[];


  constructor(
              private purchaseInvoiceService : PurchaseInvoiceService, 
              private router : Router, 
              private themeService: NbThemeService,
              private decimalPipe: DecimalPipe
             ) { }

    ngOnInit() {
      this.getAllGRN();   
      
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
         });
    }

 
  getAllGRN(){
    this.purchaseInvoiceService.getAll()
     .subscribe(
        (data) => {
                  this.GRNList = data;  
                  this.filteredFinalList = this.GRNList; 
                  this.filteredTypeList = this.GRNList;               
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });          
     }

  
     checkedChangeRdoButtons(event){
       if(event.value =="All"){
        this.filteredTypeList = this.GRNList;
        this.filteredFinalList =  this.filteredTypeList;
       }
       else if(event.value =="Paid"){
        this.filteredTypeList = this.GRNList.filter((el)=>{
          return el.Status ===event.value;
        });  
        this.filteredFinalList =  this.filteredTypeList;
       }
       else if(event.value =="Unpaid"){
        this.filteredTypeList = this.GRNList.filter((el)=>{
          return el.Status ===event.value;
        });
        this.filteredFinalList =  this.filteredTypeList;
      }
     }


    getTotalBalance(){
      return this.filteredFinalList.map(totalBal=>totalBal.BalToPay).reduce((acc,value)=>acc + +value,0);
    }

    applyFilter(){
      this.filteredByNameList = this.filteredTypeList.filter((el)=>{
         return el.SupName.toLowerCase().indexOf(this.searchKey.trim().toLowerCase()) !==-1;
       });
       this.filteredFinalList =  this.filteredByNameList;
     }
     onSearchClear(){
       this.searchKey = "";
       this.applyFilter();
     }

     savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'landscape',

        content: [   
          { text: 'Supplier Outstanding Report', style: 'reportHeader' }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto'],  
                body: [  
                  ['GrnNo', 'PurchaseDate', 'Supplier', 'Status', 'InvoiceTotal', 'AmountPaid', 'Balance'],
                  ...this.filteredFinalList.map(p => ([p.GrnNo, moment(p.GrnDate).format("YYYY-MM-DD"), p.SupName, p.Status, {text : this.transformNumberFormat(p.GrandTotal), alignment: 'right'  }, { text : this.transformNumberFormat(p.AmountPaid),alignment: 'right'  }, { text: this.transformNumberFormat(p.BalToPay),alignment: 'right' }])),  
                  [ { text: 'Total balance payable', bold: true, colSpan: 6 }, {},{},{},{},{}, { text :  this.transformNumberFormat(this.getTotalBalance()),alignment: 'right', bold : true } ]  
                ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 15],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('supBalReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Supplier Outstanding Report.xlsx');
       
     }

     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
     }

}
